export default __webpack_public_path__ + "images/OU.0de4670.png";